import { render, staticRenderFns } from "./ClientAdditionalInformation.vue?vue&type=template&id=670247ec&scoped=true"
import script from "./ClientAdditionalInformation.vue?vue&type=script&lang=js"
export * from "./ClientAdditionalInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670247ec",
  null
  
)

export default component.exports